<div class="iframe-container">
  <div class="cxone-agent-container" id="launchCXA">Carregando Iframe...></div>
</div>
